import React, { Component } from "react";
import arrPrev from '../../images/line-md_arrow-left.png';
import nextArrow from '../../images/line-md_arrow-right.png';
import * as Constanti from '../../Utils/constants.js';
import '../../style/categoriauno.css';
import '../../style/generic.css';
import Slider from "react-slick";
import axios from "axios";
import CardThree from "../cards/cardThree.js";
import ellipse from '../../images/Ellipse6.png';
import { Link } from "react-router";
import { motion } from "framer-motion";


class Category4 extends Component{
  constructor(props){
    
    super(props);
    this.state = {
      video: [],
           activeSlide: 0, 
            load: true, 
      }
      this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
      // 2. Lega la nuova funzione
        this.handleAfterChange = this.handleAfterChange.bind(this); 
}

 handleAfterChange(current) {
        this.setState({ activeSlide: current });
    }


next() {
  this.slider.slickNext();
}
previous() {
  this.slider.slickPrev();
}


  componentDidMount() {
    var apiBaseUrl = Constanti.url_Backend+"getVideoByCategory";
    var payload= {
      "id_categoria": this.props.category,
      "limit":this.props.limit,
      "idEsclusi":this.props.idEscludere
    }
    
      var self = this;
      axios.post(apiBaseUrl, payload).then(function (response) {
      if (response.data.data != null){
         var location = response.data.data;
         self.setState({ video : location })
      }else{
        console.log("non ci sono video per questo id");
      }
      self.setState({load:false});
    })
    .catch(function (error) {
    console.log(error);
    self.setState({load:false});
    });

  }

  render(){
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      centerMode: false,
      centerPadding: '60px',
      slidesToShow:1, 
      slidesToScroll: 1,
      variableWidth: true,
       afterChange: this.handleAfterChange, 
    };
    const { video,activeSlide } = this.state;
       const prevButtonClass = `buttonSlider left ${activeSlide === 0 ? 'hidden-button' : ''}`;
         if (!video || video.length === 0) {
      return null;
    }
  return (
<section className="categorysection darkblue-bg relative">
 <div className="hero-img">
    <img src={Constanti.url_img_new+this.props.categoria.thumbnail} alt="" className="img-hero"/>
    </div>
    <div className="hero-leftcategory"></div>
      <div className="hero-video-info height-100">
      <div className="container textWhite height-100">
      <div className="flex vertical align-start justify-end height-100 heroMobileTile">
        <div className="HeroCatTitle padding-bottom-16 padding-top-32">
         {this.props.name}
          </div>
          <div className="HeroCatDesc padding-bottom-32">
         {this.props.categoria.descrizione}
          </div>
          <div className="buttonHero">
              <Link to={'/categoria/'+this.props.category} className="button secondary small w-button heigth-32">Vedi tutti</Link>
          </div>
      </div>
    </div>
    </div>
    
<div className="container">
  <div className="slider-wrapper">
    <div className="slider-hover-wrapper">
    <div className="divButton ">
      <button className="buttonSlider left" onClick={this.previous}>
          <img className={prevButtonClass} height={51}  width={51} src={arrPrev}/>
          </button>
          <button className="buttonSlider right" onClick={this.next}>
          <img className="next-slick-arrow" src={nextArrow}  height={51}  width={51} />
          </button>
    </div>
    <div className="container-home slider-container" >
    <Slider ref={c => (this.slider = c)} {...settings}>
      {video != null && video?.map((el, index) => (
               <motion.div
                               key={el.id}
                               initial={{ opacity: 0, y: 60 }}
                               whileInView={{ opacity: 1, y: 0 }}
                               viewport={{ once: true, amount: 0.2 }}
                               transition={{
                                 duration: 0.9,
                                 delay: index * 0.2,
                                 ease: "easeOut"
                               }}
                                    style={{ display: "flex" }}
                             >
     <Link to={'/video/'+el.id}> 
    <CardThree key={el.id} thumbnail={el.thumbnail} title={el.title} data={el.created_at} onClick={() => alert("ho risolto naaaaand")}></CardThree>
    </Link>
    </motion.div>
    ))}
     </Slider>
   </div>
   </div>
   </div>
   </div>
   </section>
    )
}
}
export default Category4; 





